import { useEffect, useRef } from "react";

import { ScrollTrigger, gsap, prefersReducedMotion } from "../lib/motion";
import "./BrushWord.css";

/**
 * The amber brush-stroke highlight behind a key word — the reference site's
 * strongest typographic device, using its own `yellow-bg.png` asset.
 *
 * The original loops the stroke on a 3s timer, so it spends most of its life
 * mid-flash. Here it paints on once as the heading arrives, and stays. Driven
 * with scaleX rather than width, so it never touches layout.
 */
export default function BrushWord({ children, variant = "section", delay = 0 }) {
  const brushRef = useRef(null);

  useEffect(() => {
    const el = brushRef.current;
    if (!el) return undefined;

    if (prefersReducedMotion()) {
      gsap.set(el, { scaleX: 1, opacity: 1 });
      return undefined;
    }

    const tween = gsap.fromTo(
      el,
      { scaleX: 0, opacity: 0.9 },
      {
        scaleX: 1,
        opacity: 1,
        duration: 0.72,
        delay,
        ease: "power2.inOut",
        scrollTrigger: { trigger: el, start: "top 92%", once: true },
      },
    );

    return () => {
      tween.scrollTrigger?.kill();
      tween.kill();
      ScrollTrigger.refresh();
    };
  }, [delay]);

  return (
    <span className={`brush brush--${variant}`}>
      <span className="brush__text">{children}</span>
      <img
        ref={brushRef}
        className="brush__stroke"
        src="/assets/shape/yellow-bg.png"
        alt=""
        aria-hidden="true"
        width="1284"
        height="102"
      />
    </span>
  );
}
